<div class="chip-container">
  <mat-chip-list aria-label="product categories">
    <mat-chip
      *ngFor="let category of categories"
      class="outline-chip"
      (click)="goToCategory(category)"
    >
      {{ category.name }}
    </mat-chip>
  </mat-chip-list>
</div>
